<mat-card class="card">
  @if (!isBasicUser()) {
    <div class="flex justify-between items-center">
      <mat-button-toggle-group
        class="main-toggle-group"
        (change)="tab.set($event.value)"
        [value]="tab()"
      >
        <mat-button-toggle [value]="eTabs.ACTIONS">
          Actions
        </mat-button-toggle>
        <mat-button-toggle [value]="eTabs.REMOTE">
          Remote
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  }

  @if (tab() === eTabs.ACTIONS) {
    <avs-device-actions
      [deviceId]="deviceId()"
      [twoWayCommunication]="twoWayCommunication()"
    />
  }

  @if (tab() === eTabs.REMOTE) {
    <avs-remote-action-list
      (remoteActionsChanged)="remoteActionsChanged.emit()"
      [deviceId]="deviceId()"
      [editable]="editable()"
      [twoWayCommunication]="twoWayCommunication()"
    />
  }
</mat-card>
